import { useEffect } from 'react';
import { socket } from '../socket';
import { WsEvents } from '../events';
import { useDispatch } from 'react-redux';
import {
  addPriorityOrderSuccess,
  deletePriorityOrderSuccess,
  updatePriorityOrderSuccess,
} from '../../store/priority/actions';

export function usePriorityOrders() {
  const dispatch = useDispatch();

  /**
   * Add Event Hook
   */
  useEffect(() => {
    function onAddEvent(res) {
      if ('error' in res) return;
      dispatch(addPriorityOrderSuccess(res));
    }
    socket.on(WsEvents.priority.ON_ADDED, onAddEvent);

    return () => {
      socket.off(WsEvents.priority.ON_ADDED, onAddEvent);
    };
  }, [dispatch]);

  /**
   * Update Event Hook
   */
  useEffect(() => {
    function onUpdateEvent(res) {
      if ('error' in res) return;
      dispatch(updatePriorityOrderSuccess(res));
    }
    socket.on(WsEvents.priority.ON_UPDATED, onUpdateEvent);

    return () => {
      socket.off(WsEvents.priority.ON_UPDATED, onUpdateEvent);
    };
  }, [dispatch]);

  /**
   * Delete Event Hook
   */
  useEffect(() => {
    function onDeleteEvent(res) {
      if ('error' in res) return;
      dispatch(deletePriorityOrderSuccess(res));
    }
    socket.on(WsEvents.priority.ON_DELETED, onDeleteEvent);

    return () => {
      socket.off(WsEvents.priority.ON_DELETED, onDeleteEvent);
    };
  }, [dispatch]);

  return null;
}
